<template>
  <nav class="navigation" :class="{ 'is-open': isOpen }">
    <div class="navigation__logo">
      <router-link to="/">
        <img src="../assets/img/logo.png" alt="Logo">
      </router-link>
      <span class="navigation__logo--subtitle">Projects for Sustainable Development - Global Marketing of Photovoltaics</span>
    </div>
    <div class="navigation__burger">
      <a href="#" v-on:click.stop.prevent="open">
        <svg width="65" height="34" viewBox="0 0 65 34" fill="none">
          <line x1="1" y1="1" x2="64" y2="1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="1" y1="17" x2="64" y2="17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="1" y1="33" x2="64" y2="33" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </div>
    <ul class="navigation__list">
      <!-- <li class="navigation__list--item is-active">
        <router-link to="/"><h4>Home</h4></router-link>
      </li> -->
      <router-link to="/services" tag="li" class="navigation__list--item">
        <span v-on:click="open">Services</span>
      </router-link>
      <router-link to="/news" tag="li" class="navigation__list--item">
        <span v-on:click="open">News</span>
      </router-link>
      <router-link to="/about" tag="li" class="navigation__list--item">
        <span v-on:click="open">About Us</span>
      </router-link>
      <router-link to="/" tag="li" class="navigation__list--item no-link">
        <span v-on:click="scrollTo('contact-form')">Contact</span>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'app-navigation',

  data: () => ({
    isOpen: false,
  }),

  methods: {
    open() {
      this.isOpen = !this.isOpen;
    },
    scrollTo(id) {
      this.open();
      setTimeout(() => {
        const element = document.getElementById(id);
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    },
  },
};
</script>

<style>

</style>
